import { render } from "./titleHeader3.vue?vue&type=template&id=0bdd325e"
import script from "./titleHeader3.vue?vue&type=script&lang=js"
export * from "./titleHeader3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__